import { Link } from 'react-router-dom';

export default function FeaturedHighlights() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 font-label text-xs tracking-wide uppercase mb-4">Highlights</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950">
            Curated <span className="text-accent-500">Resources</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Everything you need for a smarter CSSBuy shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="md:col-span-1 md:row-span-2 rounded-2xl overflow-hidden bg-background-100 relative group cursor-pointer">
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylish%20streetwear%20outfit%20flat%20lay%20featuring%20sneakers%20hoodie%20and%20accessories%20on%20a%20clean%20minimal%20cream%20background%2C%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20soft%20shadows%2C%20clean%20composition%2C%20neutral%20warm%20tones&width=700&height=950&seq=highlight-editor-2026&orientation=portrait"
                alt="Editor's Pick CSSBuy spreadsheet collection"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                title="CSSBuy Spreadsheet - Editor's Pick"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 font-label text-xs font-semibold mb-3">Editor's Pick</span>
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-background-50">Trending Now</h3>
              <p className="text-background-50/75 text-xs md:text-sm mt-2">The most popular spreadsheet finds this month</p>
            </div>
          </div>

          <Link
            to="/cssbuy-sheet-guide"
            className="md:col-span-2 rounded-2xl overflow-hidden bg-secondary-100 p-6 md:p-8 flex flex-col justify-between group cursor-pointer min-h-[180px]"
          >
            <div>
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-secondary-200 mb-4">
                <i className="ri-book-open-line text-xl text-secondary-700"></i>
              </div>
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-900">Buying Guide</h3>
              <p className="text-foreground-500 text-sm mt-2 max-w-md">
                Comprehensive step-by-step guide to using CSSBuy spreadsheets like a pro. Learn how to find the best deals and trusted sellers.
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm font-label font-semibold text-secondary-700 group-hover:text-secondary-800 transition-colors mt-4">
              Read Guide <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </div>
          </Link>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="md:col-span-2 rounded-2xl overflow-hidden bg-accent-50 p-6 md:p-8 flex flex-col justify-between group cursor-pointer min-h-[180px]"
          >
            <div>
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                <i className="ri-search-eye-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-900">QC Center</h3>
              <p className="text-foreground-500 text-sm mt-2 max-w-md">
                Quality check references and guides to help you inspect products before shipping. Spot flaws and verify authenticity with confidence.
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm font-label font-semibold text-accent-600 group-hover:text-accent-700 transition-colors mt-4">
              Visit QC Center <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}